import SubAccountList from "./AccountList/SubAccountList";
import { Box } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import PageWrap from "@/components/PageWrap";
import { useMedia } from "@/hooks/useMedia";
import { Flex, Text, Image } from "@chakra-ui/react";
import BackBtn from "./components/BackBtn";
import AddBtn from "./components/AddBtn";
import { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  PageContainer,
  TabWrap,
  Tab,
  ApiKeyWarning,
  CreateLimit,
  ListHeaderWrap,
  SearchInputWrap,
} from "./styles";
import { TAB_MAPS, APPLY_STATUS_MAPS } from "./constants";
import ApiKeyList from "./ApiKeyList/List";
import { useHooks } from "./hooks";
import ApplyModal from "./components/ApplyModal";
import ApplyPendingModal from "./components/ApplyPendingModal";
import { getSubAccountInfoApi } from "@/api/subAccount";
import { useAppSelector } from "@/state/hooks";
import { toastTip } from "@/components/ui/toast";

const SubAccountPage = () => {
  const { t } = useI18n();
  const { isMobile } = useMedia();
  const [currTab, setCurrTab] = useState(TAB_MAPS.SUB_ACCOUNT);
  const navigate = useNavigate();
  const { maxCreateAccountNum, maxApiKeyNum } = useHooks();
  const [searchInputValue, setSearchInputValue] = useState("");
  const [showApplyModal, setShowApplyModal] = useState(false);
  const [showApplyPendingModal, setShowApplyPendingModal] = useState(false);
  const [applyStatus, setApplyStatus] = useState(""); // 申请状态
  const [accountLen, setAccountLen] = useState(0);

  const { userInfo } = useAppSelector((state) => state.user);

  const getSubAccountInfo = async () => {
    const res = await getSubAccountInfoApi();
    if (res.code === 0) {
      const { status } = res.data;
      setApplyStatus(status);
    }
  };

  useEffect(() => {
    if (userInfo?.uid) {
      getSubAccountInfo();
    }
  }, [userInfo]);

  const memoTabs = useMemo(() => {
    return [
      {
        label: t("wtPiDpoJwweHEwGphG"),
        value: TAB_MAPS.SUB_ACCOUNT,
      },
      // {
      //   label: t("nirNFLwkcuvUxudti"),
      //   value: TAB_MAPS.API_KEY,
      // },
    ];
  }, [t]);

  const memoAddBtnText = useMemo(() => {
    if (currTab === TAB_MAPS.SUB_ACCOUNT) {
      return t("kdGDbDfHqPdMmOODj");
    }
    return t("bgnQSQsWYPIcUDEytcq");
  }, [t, currTab]);

  const addBtnClick = () => {
    if (currTab === TAB_MAPS.SUB_ACCOUNT) {
      if (applyStatus === APPLY_STATUS_MAPS.NOT_APPLY) {
        setShowApplyModal(true);
      } else if (applyStatus === APPLY_STATUS_MAPS.PENDING) {
        setShowApplyPendingModal(true);
      } else if (maxCreateAccountNum === accountLen) {
        toastTip(t("EyxlrwvHrdhvRaHtLxx").replace("$s", maxCreateAccountNum), {
          type: "error",
        });
      } else {
        navigate("/trade/subAccount/add");
      }
    } else {
      navigate("/trade/subAccount/apiKey/add");
    }
  };

  const memoLimitText = useMemo(() => {
    if (currTab === TAB_MAPS.SUB_ACCOUNT) {
      return t("EyxlrwvHrdhvRaHtLxx").replace("$s", maxCreateAccountNum);
    } else {
      return t("GqlajLqwcNJLpTqq");
    }
  }, [maxCreateAccountNum, t, currTab]);

  return (
    <>
      <PageWrap>
        <PageContainer pt={!isMobile ? "30px" : "0"}>
          <Box w={["100%", "1200px"]} margin={"0 auto"}>
            {/* 头部 */}
            <Flex
              justifyContent={"space-between"}
              alignItems={"center"}
              flexDirection={isMobile ? "column" : "row"}
              padding={"0 30px"}
            >
              {!isMobile ? (
                <>
                  <BackBtn />
                  <Text size={24} fontWeight={600}>
                    {t("YFShWZLtmVzhKApQSudo")}
                  </Text>
                  <AddBtn
                    title={memoAddBtnText}
                    onClick={addBtnClick}
                    status={applyStatus}
                  />
                </>
              ) : (
                <>
                  <Flex w={"100%"} justifyContent={"space-between"}>
                    <BackBtn />
                  </Flex>
                  <Flex
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    w={"100%"}
                  >
                    <Text size={24} fontWeight={600}>
                      {t("YFShWZLtmVzhKApQSudo")}
                    </Text>
                    <AddBtn
                      onClick={addBtnClick}
                      status={applyStatus}
                      title={memoAddBtnText}
                    />
                  </Flex>
                </>
              )}
            </Flex>

            <Box
              mt={["30px", "55px"]}
              padding={"0 30px"}
              paddingBottom={"40px"}
            >
              <ListHeaderWrap
                mb={currTab === TAB_MAPS.SUB_ACCOUNT ? "20px" : "0px"}
              >
                <Flex>
                  <TabWrap>
                    {memoTabs.map((d, i) => {
                      return (
                        <Tab
                          key={i}
                          onClick={() => setCurrTab(d.value)}
                          className={d.value === currTab ? "active" : ""}
                        >
                          {d.label}
                        </Tab>
                      );
                    })}
                  </TabWrap>
                  <CreateLimit ml={!isMobile ? "30px" : "10px"}>
                    <Image src="../wwwsite/images/kyc/kyc_tip.svg" />
                    {memoLimitText}
                  </CreateLimit>
                </Flex>

                {currTab === TAB_MAPS.API_KEY && (
                  <SearchInputWrap>
                    <Image src="../wwwsite/images/search.svg" />
                    <input
                      placeholder={t("OsCIqseGbbbWXxBLk")}
                      value={searchInputValue}
                      onChange={(e) => {
                        setSearchInputValue(e.target.value);
                      }}
                    />
                  </SearchInputWrap>
                )}
              </ListHeaderWrap>

              {currTab === TAB_MAPS.API_KEY && (
                <ApiKeyWarning>
                  <Image src="../wwwsite/images/error-tip.svg" />
                  {t("NKaDUgPomETDmcmKHy")}
                </ApiKeyWarning>
              )}

              {currTab === TAB_MAPS.SUB_ACCOUNT && (
                <SubAccountList setAccountLen={setAccountLen} />
              )}
              {currTab === TAB_MAPS.API_KEY && (
                <ApiKeyList searchValue={searchInputValue} />
              )}
            </Box>
          </Box>
        </PageContainer>
      </PageWrap>

      <ApplyModal
        onOK={(status) => {
          setApplyStatus(status);
          setShowApplyModal(false);
          if (status === APPLY_STATUS_MAPS.PENDING) {
            setShowApplyPendingModal(true);
          }
        }}
        show={showApplyModal}
        onCancel={() => setShowApplyModal(false)}
      />
      <ApplyPendingModal
        show={showApplyPendingModal}
        onCancel={() => setShowApplyPendingModal(false)}
        onOK={() => setShowApplyPendingModal(false)}
      />
    </>
  );
};

export default SubAccountPage;
